var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ckeditor',{ref:"ckeditor4",staticClass:"content",attrs:{"value":_vm.value,"editor-url":_vm.editor,"config":_vm.editorConfig},on:{"input":function($event){return _vm.$emit('input', $event)},"ready":_vm.onReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }